import { render, staticRenderFns } from "./PortalNotice.vue?vue&type=template&id=07d2e161&scoped=true"
import script from "./PortalNotice.vue?vue&type=script&lang=js"
export * from "./PortalNotice.vue?vue&type=script&lang=js"
import style0 from "./PortalNotice.vue?vue&type=style&index=0&id=07d2e161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2e161",
  null
  
)

export default component.exports